import { getUser } from '../services/getUser';
import { createAppAsyncThunk } from '../utils/redux/createAppAsyncThunk';

export const fetchUser = createAppAsyncThunk('user/fetchUser', (_, { extra: context }) => {
  return getUser(context);
});
